import { render } from "./CookieDetail.vue?vue&type=template&id=5a7baada&scoped=true"
const script = {}

import "./CookieDetail.vue?vue&type=style&index=0&id=5a7baada&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7baada"]])

export default __exports__